var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcronymLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.419,
    height: 60,
    viewBox: "0 0 123.419 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-259.29 -611.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M357.591,612.11l-17.769,47.8a19.76,19.76,0,0,1-4.924,8.049c-2.239,2.116-5.452,3.187-9.564,3.187-.242,0-.478-.007-.709-.014-.145,0-.293-.007-.429-.019-.157,0-.306-.014-.456-.028l1.666-12.639a.682.682,0,0,0,.171.014.992.992,0,0,0,.723-.21,2.506,2.506,0,0,0,.66-1.03l16.752-45.108Z",
    transform: "translate(25.118 0.271)",
    fill: "#040505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M350.527,658.714l-1.669,12.639a1.452,1.452,0,0,1-.192-.014c-.272-.019-.538-.047-.8-.081-.2-.029-.416-.054-.613-.089-.253-.04-.5-.083-.735-.136-.19-.042-.381-.082-.566-.129-.288-.068-.564-.15-.838-.231-.253-.083-.5-.164-.737-.253l-.352-.143c-.158-.06-.307-.129-.457-.2-.075-.035-.143-.068-.22-.1-.135-.068-.271-.135-.407-.211-.108-.054-.217-.115-.32-.177a6.942,6.942,0,0,1-.782-.5c-.171-.115-.342-.238-.5-.367a.489.489,0,0,1-.068-.056c-.179-.142-.356-.286-.518-.442a8.62,8.62,0,0,1-.659-.653,13.85,13.85,0,0,1-3.494-9.786V644.231h-.008v-9.207h.008v-9.5a1.458,1.458,0,0,0-.321-1.069.85.85,0,0,0-.707-.285c-.655,0-1.11.189-1.437,1.116l-13.287,34.906a19.713,19.713,0,0,1-4.917,8.042c-2.24,2.109-5.453,3.18-9.553,3.18-4.535,0-8.021-1.294-10.372-3.84a13.843,13.843,0,0,1-3.492-9.786V626.084a1.165,1.165,0,0,0-.307-.709.939.939,0,0,0-.763-.306.958.958,0,0,0-.728.211,2.525,2.525,0,0,0-.668,1.021l-16.811,45.113H259.29l17.84-47.8a19.827,19.827,0,0,1,4.95-8.056c2.249-2.111,5.475-3.181,9.61-3.181.272,0,.543,0,.824.015,4.14.156,7.361,1.437,9.574,3.827a13.784,13.784,0,0,1,3.508,9.784v31.3a1.617,1.617,0,0,0,.318,1.152.844.844,0,0,0,.709.271,1,1,0,0,0,.707-.238,2.21,2.21,0,0,0,.662-1l13.265-34.858a19.493,19.493,0,0,1,4.972-8.042c2.261-2.117,5.481-3.18,9.586-3.18,4.536,0,8.01,1.3,10.34,3.841a14.133,14.133,0,0,1,3.444,9.867v32.182a1.433,1.433,0,0,0,.335,1.116.87.87,0,0,0,.293.213.251.251,0,0,0,.081.035.583.583,0,0,0,.182.046c.008,0,.022.008.038,0",
    fill: "#f26822"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcronymLogo);
export default __webpack_public_path__ + "static/media/acronym-logo.7824db38b5b6f6d34c4480444633e206.svg";
export { ForwardRef as ReactComponent };